import { Key } from "@mui/icons-material";
import DrawerLayout from "./components/DrawerLayout";
import { PrivateRoute } from "./components/PrivateRoute";
import { IoCredentials, Login, Unauthorized } from "./pages";
import Show from "pages/IoCredentials/Show";
import Users from "pages/Users";

export const routes = [
  {
    path: "/",
    title: 'Login',
    element: <Login />,
  },
  {
    path: "/io_credentials",
    title: 'Credenciais',
    icon: <Key color="primary" />,
    showInSideDrawer: true,
    element:
      <PrivateRoute>
        <DrawerLayout>
          <IoCredentials />
        </DrawerLayout>
      </PrivateRoute>,
  }, {
    path: "/io_credentials/:ioCredentialId",
    title: 'Credenciais',
    icon: <Key color="primary" />,
    showInSideDrawer: false,
    element:
      <PrivateRoute>
        <DrawerLayout>
          <Show />
        </DrawerLayout>
      </PrivateRoute>,
  },
  {
    path: "/admin",
    title: 'Painel administrativo',
    icon: <Key color="primary" />,
    showInSideDrawer: true,
    adminRestricted: true,
    element:
      <PrivateRoute>
        <DrawerLayout>
          <Users />
        </DrawerLayout>
      </PrivateRoute>,
  },
  {
    path: "/401",
    title: '401',
    element:
      <PrivateRoute>
        <Unauthorized />
      </PrivateRoute>,
  }
]